import { randomInt } from 'node:crypto'
// import { type Route.LoaderArgs } from 'react-router'
// import { useLoaderData } from 'react-router'
import { Icon } from '#app/components/ui/icon.tsx'
// import { Progress } from '#app/components/ui/progress.tsx'

export async function loader(/* { request }: Route.LoaderArgs */) {
	const ditches = Array.from({ length: 10 }, () => randomInt(1, 100))
	return { ditches }
}

export default function TimelineRoute() {
	// const { ditches } = useLoaderData<typeof loader>()
	// const [ditch9west, ditch9east, ...rest] = ditches

	return (
		<div className="h-vh mb-8 flex w-full flex-col gap-1 p-1">
			<div className="container my-8 flex flex-col items-center justify-center gap-6">
				<h1 className="text-center text-h1">Irrigation Tracking</h1>
				<h2 className="text-h3">
					<Icon
						name="droplets"
						className="mx-1 h-8 w-8 p-1"
						aria-hidden="true"
					/>
					Where is the water currently?
					<Icon
						name="droplet"
						className="mx-1 h-8 w-8 p-1"
						aria-hidden="true"
					/>
				</h2>
				<h3 className="text-h4">Ditches 1-4 [10-01] | [10-03] Ditches 5-8</h3>
			</div>

			<div
				id="background"
				className="mx-40 flex h-[1724px] min-h-[1724px] w-[1770px] min-w-[1770px] flex-row gap-1 bg-[url('/img/neighborhood.png')] bg-no-repeat"
			>
				<div
					id="left-margin"
					className="h-full w-[180px] border-2 border-black"
				></div>
				<div id="ditches" className="flex h-full flex-col">
					<div id="ditch-9" className="flex h-4 w-full flex-row">
						{Array.from({ length: 10 }).map((_, i) => (
							<div
								key={`ditch-9-position-${i}`}
								className="h-4 w-4 border-2 border-black"
							></div>
						))}
					</div>
					<div id="north-south-ditches" className="flex h-full w-full flex-row">
						{Array.from({ length: 8 }).map((_, ditch) => (
							<div
								key={`ditch-${ditch}`}
								className="h-full w-[180px] border-2 border-black"
							>
								{Array.from({ length: 35 }).map((_, property) => (
									<div
										key={`ditch-${ditch}-position-${property}`}
										className="h-12 w-full border-2 border-black"
									></div>
								))}
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	)
}
